import { Component, OnInit, Inject } from '@angular/core';
import { MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormGroup, FormBuilder } from '@angular/forms';
import { ProcedureCodesService } from 'src/app/Services/ProcedureCodes/procedure-codes.service';
import { ToastrService } from 'ngx-toastr';
import { ISnomed, ISnomedDX } from 'src/app/models/IProcedureCodes';
import { IOrdersLoinc } from 'src/app/models/ICptOrdersComponent';
import { IDxIcdCodes } from 'src/app/models/IDXDetails';
import { AnonymousSubject } from 'rxjs-compat';
import { DxService } from 'src/app/Services/NewVisitNote/dx.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-dxsnomedmaster',
  templateUrl: './dxsnomedmaster.component.html',
  styleUrls: ['./dxsnomedmaster.component.css']
})

export class DxsnomedmasterComponent implements OnInit {

  DxSnoMedMasterForm: FormGroup;
  dataSource = new MatTableDataSource();
  blue: string = '#BAFBC1';
  white: string = '#FFFFF';
  searchresults: string = "";
  ordersLoincCodes: ISnomedDX[] = [];
  selectIcdCode: IDxIcdCodes;
  displayedColumns: string[] = ['cptcode', 'description'];
  constructor(private formBuilder: FormBuilder,
    private dxService: DxService, private procedureCodesService: ProcedureCodesService, private toastr: ToastrService, private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<DxsnomedmasterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ISnomedDX, public dialog: MatDialog) { }

  ngOnInit() {
    this.DxSnoMedMasterForm = this.formBuilder.group({
      MasterCptlist: ['']
    });
  }

  onMasterCptSearch() {
    this.searchMasterSnomedcodes();
  }

  public MasterCPTList: ISnomed[];
  searchMasterSnomedcodes() {
    this.spinner.show();
    var searchText = this.DxSnoMedMasterForm.value.MasterCptlist;
    if (searchText != null && searchText != undefined && searchText != '') {
      this.procedureCodesService.getSnomedBySearch(searchText).subscribe(
        results => {
          this.MasterCPTList = results;
          if (results.length == 0) {
            this.searchresults = "No search results found.";
          }
          else {
            this.searchresults = "";
          }
          this.dataSource.data = this.MasterCPTList;
          this.spinner.hide();
        }, (err: any) => {

          console.log(err);
          this.spinner.hide();
        }
      );
    }
  }


  public newMasterrecord: IDxIcdCodes[] = [];
  public selectedMasterrecords: IDxIcdCodes[] = [];
  selectedCPTCodes(index, element: ISnomed, event: boolean) {

    if (event == true) {
      var obj: any = {
        icdCode: element.ConceptCode,
        icdCodeDescription: element.ConceptName,
        type: 'SNOMED',
        categoryId: this.data.categoryId,
        linkedEncounter: '',
        isActive: 1
      }
      this.newMasterrecord.push(obj);
    } else {
      this.newMasterrecord = this.newMasterrecord.filter(ele => ele.icdCode != element.ConceptCode && ele.icdCodeDescription != element.ConceptName);
    }

  }
  dxAllIcdCodes: IDxIcdCodes[] = [];
  AddCPTMaster() {
    this.spinner.show();
    if (this.newMasterrecord.length == 0) {
      this.toastr.error("Please select Snomed Number");
      this.spinner.hide();
    } else {
      this.dxService.addSnoMedInfo(this.newMasterrecord).subscribe(
        results => {
          if (results) {
            this.spinner.show();
            //this.dialogRef.close(this.newMasterrecord);
            this.dxService.getDxIcdCodes().subscribe((data) => {
              this.dxAllIcdCodes = data;
              if (this.newMasterrecord.length > 0) {
                this.selectedMasterrecords = this.dxAllIcdCodes.filter(o1 => this.newMasterrecord.some(o2 => o1.categoryId === o2.categoryId && o1.icdCode === o2.icdCode && o1.icdCodeDescription === o2.icdCodeDescription));
                this.dialogRef.close(this.selectedMasterrecords);
              }
              else {
                this.selectedMasterrecords = [];
                this.dialogRef.close(this.selectedMasterrecords);
              }
              this.spinner.hide();
            }, (err: any) => {
              console.log(err);
              this.spinner.hide();
            });

          }
          this.spinner.hide();
        },
        (err: any) => {
          console.log(err);
          this.spinner.hide();
        });

    }
  }
  selectedRowIndex: number = -1;
  oncellclick(row) {
    this.selectedRowIndex = row.cptMasterId;
  }
  CancelCPTMaster() {
    this.dialogRef.close('cancel');
  }
}
// export interface DialogData {
//   headerText: string;
//   columnName: string;
// }
